import { render, staticRenderFns } from "./addanswer.vue?vue&type=template&id=5669b88c&scoped=true"
import script from "./addanswer.vue?vue&type=script&lang=js"
export * from "./addanswer.vue?vue&type=script&lang=js"
import style0 from "./addanswer.vue?vue&type=style&index=0&id=5669b88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669b88c",
  null
  
)

export default component.exports